export default __webpack_public_path__ + "static/media/logo_white.96357da3.svg";